import { EventEmitterFactory } from 'pf-frontend-common/src/module/event/emitter.factory';
import { WindowService } from 'pf-frontend-common/src/service/window/service';

import { BuildingReviewLandingFormViewStore } from 'common/module/building-review-landing/form/view-store';
import { StatsGtmProviderService } from 'common/service/stats-gtm-provider/service';

const service = new BuildingReviewLandingFormViewStore(
  EventEmitterFactory(),
  WindowService(),
  StatsGtmProviderService()
);

export function BuildingReviewLandingFormService(): BuildingReviewLandingFormViewStore {
  return service;
}
